"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var getFlag = function getFlag(resultGrade, resultGradeFlip) {
  if (resultGradeFlip) {
    return resultGrade ? 'fail' : 'pass';
  } else {
    return resultGrade ? 'pass' : 'fail';
  }
};

var Tag = function Tag(_ref) {
  var resultGrade = _ref.resultGrade,
      resultGradeFlip = _ref.resultGradeFlip;
  var resultGradeFlag = getFlag(resultGrade, resultGradeFlip);
  return _react.default.createElement("div", {
    className: "tag-wrapper"
  }, _react.default.createElement("div", {
    className: "tag tag-" + resultGradeFlag
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "results.data." + resultGradeFlag
  })));
};

var _default = Tag;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/result/Tag.js
// module id = 150
// module chunks = 0